import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// user info
import User from "./user/reducer";

// Authentication Module
import Account from "./auth/register/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  // user info
  User,
  Account,
});

export default rootReducer;
